import { render, staticRenderFns } from "./NotesDialogChart.vue?vue&type=template&id=a0f1e606&scoped=true&"
import script from "./NotesDialogChart.vue?vue&type=script&lang=js&"
export * from "./NotesDialogChart.vue?vue&type=script&lang=js&"
import style0 from "./NotesDialogChart.vue?vue&type=style&index=0&id=a0f1e606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f1e606",
  null
  
)

export default component.exports